<template>
    <v-card>
    <v-navigation-drawer
    v-model="right_drawer"
    app dark      
    right
    width="400px"
    >
      <template v-slot:prepend>
        <v-list-item >
          <!--
          <v-list-item-avatar>
            <img :src="entity_type_image">
          </v-list-item-avatar>
          -->
          <v-list-item-icon>
           <v-icon> mdi-plus-circle </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">Project Creation</v-list-item-title>
            
          </v-list-item-content>
           <v-btn
          icon
          @click.stop="close_right_sidebar" 
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        </v-list-item>
      

      </template>

      <v-divider></v-divider>

  <template>
  <v-form
    class="mx-2"
    ref="form"
    v-model="valid"
    lazy-validation
  >                                         
    <v-text-field
      v-model="title"
      :counter="100"
      :rules="titleRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Title of the Project
    </template>
    </v-text-field>

     <v-text-field
      v-model="latitude"
      
      :rules="latitudeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Latitude (in WGS-84 reference system)
    </template>
    </v-text-field>
     <v-text-field
      v-model="longitude"
      
      :rules="longitudeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Longitude (in WGS-84 reference system)
    </template>
    </v-text-field>
	<!--  because we removed range from project
    <v-text-field
      v-model="range"
      
      :rules="rangeRules"
      required>
      <template #label>
      <span class="red--text"><strong>* </strong></span>Range
    </template>
    </v-text-field> -->
    <!--
    <v-btn :loading="pick_a_point" block color="blue-grey" @click="pick_point">
       <v-icon left>mdi-map-marker</v-icon> Marker
        <template v-slot:loader>
        <span>Waiting to pick a point...</span>
      </template>

    </v-btn>  -->

    <v-textarea
          name="input-7-1"
          label="Project Description"
          v-model="description"
          hint="Insert something about the project"
        ></v-textarea>

       <v-select
        v-model="file_type"
        :items="file_types"
        label="File Type"
        style="max-width: 250px;"
        
      ></v-select>

	  <v-select
        v-model="project_visibility"
        :items="project_visibility_items"
        label="Project Visibility"
        style="max-width: 250px;"
        
      ></v-select>
       <!--
       <v-select
        v-if="file_type=='Video'"
        v-model="video_input_mode"
        :items="video_input_modes"
        label="Video Input Mode"
        style="max-width: 250px;"
      ></v-select>
      -->
      <!--
       <v-text-field
      v-if="file_type=='Video' && video_input_mode=='Link'"
      v-model="video_link"
      label="Video Link"
      required
    ></v-text-field>
    -->

      
      <v-file-input v-if="file_type=='Video'"   v-model="video_file" :rules="videoRules"  prepend-icon="mdi-video" chips show-size accept="video/*" label="Project Video"></v-file-input>
      <v-file-input v-if="file_type=='Image'" v-model="image_file"  :rules="imageRules"  prepend-icon="mdi-camera" chips show-size accept="image/*" label="Project Image"></v-file-input>

   
<v-btn
      :loading="waiting_for_storage"
      :disabled="waiting_for_storage"
      color="success"
      class="mr-6 white--text"
      @click="store_project"
    >
     
      <v-icon left dark>mdi-content-save</v-icon> Store Project
    </v-btn>

   

    <v-btn
      color="error"
      class="mr-6"
      @click="reset"
    >
      <v-icon left dark>mdi-eraser</v-icon> Reset Form
      
    </v-btn>

   
  </v-form>
</template>
   
   

  

  

  

    </v-navigation-drawer>


    <v-snackbar
      v-model="instructions_snackbar"
      :color="snackbar_color"
      :timeout= "instructions_snackbar_timeout"
      :multi-line="instructions_snackbar_multiline"
    >
      Click on map in order to set automatically latitude and longitude. Alternatively you can set manually the coordinates.  
      <v-btn
        color="red"
        text
        @click="instructions_snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>


    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :color="snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

   <v-snackbar
      v-model="file_snackbar"
      :bottom="file_snackbar_y === 'bottom'"
      :color="file_snackbar_color"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="file_snackbar_y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ file_snackbar_text }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <v-overlay light :value="overlay" z-index=1000 opacity="0.1">
    <v-progress-circular
      :rotate="-90"
      :size="100"
      :width="15"
      :value="file_upload_percentage"
      color="indigo"
    >
      {{ file_upload_percentage }}
    </v-progress-circular>
    </v-overlay>


  </v-card>




</template>

<script>
    import { componentBus } from '../main';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    export default {
        name: 'ProjectAddition',
        data: function () {
            return {

		project_visibility: 'Publish',
		project_visibility_items: ['Publish','Keep it as draft'],
		instructions_snackbar: true,
		instructions_snackbar_multiline: true,
		instructions_snackbar_timeout: 0,

        overlay: false,
        file_upload_percentage: null,

        file_upload_config : {
        headers: { 'Content-Type': 'multipart/form-data'},
        onUploadProgress: (progressEvent) => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            //alert(percentCompleted);
            this.file_upload_percentage = percentCompleted;
        }

        },      

        file_types: ['No File','Image','Video'],
        file_type: 'No File',
        //video_input_modes: ['Link','File'],
        //video_input_mode: 'Link',

        snackbar_color: '',
        mode: '',
        snackbar: false,
        snackbar_text: '',
        timeout: 4000,
        x: null,
        y: 'top',


        file_snackbar_color: '',
        file_snackbar: false,
        file_snackbar_text: '',
        file_snackbar_y: 'bottom',


      waiting_for_storage: false,
      //file: null,
      image_file: null,
      video_file: null,
      //video_link: null,
      //pick_a_point: false,
      entity_type_image: "nextGen_logo-simple.png",
      right_drawer: true,



      valid: true,
      title: '',
      titleRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 100) || 'Name must be less than 10 characters',
      ],
      latitude: null,
      latitudeRules: [
        v => !!v || 'Latitude is required (in WGS-84 reference system)',
        v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Latitude should be a Real Number (in WGS-84 reference system)',
      ],
      longitude: null,
      longitudeRules: [
        v => !!v || 'Longitude is required (in WGS-84 reference system)',
        v => /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/.test(v) || 'Longitude should be a Real Number (in WGS-84 reference system)',
      ],
       imageRules: [
        v => (!!v  && this.file_type=='Image') || 'Image is required',   
      ],
       videoRules: [
        v => (!!v  && this.file_type=='Video') || 'Video is required',   
      ],
      /* because we removed range from project           range: null,
      rangeRules: [
        v => !!v || 'Range is required',
        v => /^[1-9]\d+$/.test(v) || 'Range should be a Positive Integer',
      ], */
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      description: ''
      
      
                
            };
        },
        computed: {
            
        },
        methods: {

        store_project()
        {
           
          let valid= this.$refs.form.validate();
          //let video_link= (this.file_type=='Video' && this.video_input_mode=='Link') ? this.video_link : null;
          let video= (this.file_type=='Video') ? this.video_file : null;
          let image= (this.file_type=='Image') ? this.image_file : null;
          let multimedia_type=null;
          if(video!=null) multimedia_type=2;
          else if(image!=null) multimedia_type=1;
          else multimedia_type= 0;
		  let published= (this.project_visibility=='Publish') ? true : false;

          if( valid)    
          {
           this.waiting_for_storage=true;
           let url_query=APIS_BASE_URL+"/projects/";
           let my_url= encodeURI(url_query);
           var payload = {
                    title: this.title,
                    point: {
                      type: "Point",
                      coordinates: [parseFloat(this.longitude),parseFloat(this.latitude)]
                    },
                    //range: this.range, because we removed range from project
                    description: this.description,
                    created_by: "aaabbbccc",
                    //video_link: video_link,
                    multimedia_type: multimedia_type,
					published: published
                   
                }

           
           axios.post(my_url, payload,
                    {
                     headers: { 'Content-Type' : 'application/json'}
                               
                        }).then(response => {
                            if (response.status == "200" || response.status == "201" ) {
                              if(image==null && video==null)
                              {
                               this.waiting_for_storage=false;
                               this.snackbar_color="success";
                               this.snackbar_text="The Project has been successfully stored!"
                               this.snackbar=true;
                               this.reset();
                               this.close_right_sidebar ();

                               payload.id=response.data.id;
                               payload.uuid=response.data.project_uuid;
                               componentBus.$emit('destroy_temporary_pin', true);
                               componentBus.$emit('newly_created_project', payload);
                              } 
                               

                               //now store the file as well
                               if(image!=null) 
                               {

                                this.file_upload_percentage=0;
                                this.overlay=true;
                                
                                let upload_image_url=APIS_BASE_URL+"/projects/"+response.data.project_uuid+"/image/";
                                let upload_image_encoded_url= encodeURI(upload_image_url);
                                let formData = new FormData();
                                formData.append('file', image);

                                axios.post( upload_image_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                // }
                                this.file_upload_config
                                ).then( (image_upload_response) =>{

                                if (image_upload_response.status == "201" )
                                   {
                                    this.overlay=false;

                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The Project has been successfully updated!"
                                    this.snackbar=true;
                                    this.reset();
                                    this.close_right_sidebar ();

                                    payload.id=response.data.id;
                                    payload.uuid=response.data.project_uuid;
                                    componentBus.$emit('destroy_temporary_pin', true);
                                    componentBus.$emit('newly_created_project', payload);
                                   }
                                   //console.log('SUCCESS with image upload!!');
                                else
                                 {
                                  console.log('FAILURE with image upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with Project image storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   console.log('FAILURE with image upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with Project image storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               else if(video!=null) 
                               { //alert(video.size);
                                this.file_upload_percentage=0;
                                this.overlay=true;
                                let upload_video_url=APIS_BASE_URL+"/projects/"+response.data.project_uuid+"/video/";
                                let upload_video_encoded_url= encodeURI(upload_video_url);
                                let formData = new FormData();
                                formData.append('file', video);

                                axios.post( upload_video_encoded_url,
                                 formData,
                                 //{
                                 //headers: { 'Content-Type': 'multipart/form-data'}
                                 //}
                                 this.file_upload_config
                                ).then( (video_upload_response) =>{

                                if (video_upload_response.status == "201" )
                                   {
                                    this.overlay=false;
                                    this.waiting_for_storage=false;
                                    this.snackbar_color="success";
                                    this.snackbar_text="The Project has been successfully updated!"
                                    this.snackbar=true;
                                    this.reset();
                                    this.close_right_sidebar ();

                                    payload.id=response.data.id;
                                    payload.uuid=response.data.project_uuid;
                                    componentBus.$emit('destroy_temporary_pin', true);
                                    componentBus.$emit('newly_created_project', payload);
                                   }
                                   //console.log('SUCCESS with video upload!!');
                                else
                                 {
                                  console.log('FAILURE with video upload!!');
                                  this.file_snackbar_color="error";
                                  this.file_snackbar_text="Problem with Project video storage..."
                                  this.file_snackbar=true;
                                 }
 

                                  })
                                 .catch( () =>{
                                   console.log('FAILURE with video upload!!');
                                   this.file_snackbar_color="error";
                                   this.file_snackbar_text="Problem with Project video storage..."
                                   this.file_snackbar=true;

                                   });



                               }
                               
                               //console.log(response.data);
                            }
                            else {
                                //alert("something went wrong");
                                this.waiting_for_storage=false;
                                this.snackbar_color="error";
                                this.snackbar_text="Problem with the Project storage..."
                                this.snackbar=true;
                            }
                            //this.reset();
                    })
                    .catch(error => {
                        console.log(error);
                        //alert("something went wrong"+ error);
                        this.waiting_for_storage=false;
                        this.snackbar_color="error";
                        this.snackbar_text="Problem with the Project storage..."
                        this.snackbar=true;
                    });


           //this.close_right_sidebar ();
          }
          
        

        },
       /*
        pick_point()
         {
          this.pick_a_point= !this.pick_a_point;
         
          componentBus.$emit('pick_a_point', this.pick_a_point);

         }, */
         file_uploaded()
         {
           console.log("the user has inserted file");
           /*
         var url_query=APIS_BASE_URL+"/projects/704c29ba-4230-48c5-8420-94c646fa3154/image/";
         var my_url= encodeURI(url_query);
         let formData = new FormData();
         formData.append('file', this.file);

         axios.post( my_url,
          formData,
            {
           headers: {
           'Content-Type': 'multipart/form-data'
            }
             }
           ).then(function(){
          console.log('SUCCESS!!');
           })
           .catch(function(){
            console.log('FAILURE!!');
            });
*/
          //let reader = new FileReader()
          //reader.onload = () => {
          //this.imageUrl = reader.result
       // }
        //reader.readAsDataURL(this.file)
          //console.log(e.target.files[0].name);
          //alert("hey you");
         },

         
      reset () {
        this.$refs.form.reset();
        componentBus.$emit('destroy_temporary_pin', true);
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

            close_right_sidebar () {
            componentBus.$emit('destroy_temporary_pin', true);
            this.right_drawer = false;
            

      }

           
        },
        mounted() {
		  componentBus.$emit('pick_a_point', true);
          componentBus.$on('selected_point_coordinates', (project_point_coordinates) => {
              //if(this.pick_a_point)
                //{
                //alert("Lat, Lon : " + project_point_coordinates.lat + ", " + project_point_coordinates.lng);
                this.latitude=project_point_coordinates.lat;
                this.longitude=project_point_coordinates.lng;
               // this.pick_a_point= !this.pick_a_point;
               // }
            });

             componentBus.$on('open_the_sidebar', (parameter) => {
                console.log(parameter);
                this.$refs.form.reset();
                this.right_drawer = true;
             
            });
    
           
        },
        destroyed() {
            componentBus.$emit('stop_picking_point', true);
            componentBus.$off('selected_point_coordinates');
            componentBus.$off('open_the_sidebar');
            componentBus.$emit('destroy_temporary_pin', true);
   
        }
    };
</script>

<style scoped>
   
</style>
